/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit New/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Actions from './Actions/index'
import CreditCards from './CreditCards/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import GenerateAction from './GenerateAction/index'
import LastExecution from './LastExecution/index'
import Locations from './Locations/index'
import MinDueAmount from './MinDueAmount/index'
import Overdue from './Overdue/index'
import React from 'react'
import ReferenceDate from './ReferenceDate/index'
import Report from 'DesignSystem/Report/index'
import ReportTable from 'DesignSystem/Report/ReportTable/index'
import ToggleVersionAction from './ToggleVersionAction/index'
import TransactionsDateRange from './TransactionsDateRange/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function New({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/New"
  
}) {
let onSelectionChanged = fromHelpers.useOnChangeSelectedRows({
  children,
  viewPath
  
})
let onIsRowSelected = fromHelpers.useOnIsRowSelected({
  children,
  viewPath
  
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<Report
  viewPath={`${viewPath}/Report`}
 viewPath={viewPath}
 type="statements"
>
{childProps => (
<div
  data-testid="New.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="New.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ReportTable
  viewPath={`${viewPath}/ReportTable`}
 rowGroupPanelShow="never"
 rowSelection="multiple"
 onSelectionChanged={onSelectionChanged}
 onIsRowSelected={onIsRowSelected}
/>
</div>
<div
  data-testid="New.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-1-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-l16': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--blc-3-l16': dtColorsNeutral300,'--pb-4-l16': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical1}`}
>
<ToggleVersionAction
  viewPath={`${viewPath}/ToggleVersionAction`}
/>
<Locations
  viewPath={`${viewPath}/Locations`}
/>
<ReferenceDate
  viewPath={`${viewPath}/ReferenceDate`}
/>
<TransactionsDateRange
  viewPath={`${viewPath}/TransactionsDateRange`}
/>
<Overdue
  viewPath={`${viewPath}/Overdue`}
/>
<MinDueAmount
  viewPath={`${viewPath}/MinDueAmount`}
/>
<GenerateAction
  viewPath={`${viewPath}/GenerateAction`}
/>
<LastExecution
  viewPath={`${viewPath}/LastExecution`}
/>
<CreditCards
  viewPath={`${viewPath}/CreditCards`}
/>
</div>
</div>
)}
</Report>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
{children}
</React.Fragment>)
}